import { Box } from '@material-ui/core';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { IconArrowLeft, TypographyWrapper } from '../../components';
import { InlineTextButton } from '../../components/Button/Button';
import { ListingPageParamTab } from './EditListingPage.utils';
import { useShopConfig } from '../../hooks/shopConfig';
import { useIsMobile } from '../../hooks/useIsMobile';
import { defaultTreetStyles } from '../../shopConfig/config';
import { LISTING_STATE_DRAFT } from '../../util/types';
import BackToPreviousTabLink from './BackToPreviousTabLink';
import { EditListingPageState } from './EditListingPage.duck';
import { useOwnListingVersions } from './hooks/useOwnListingVersions';
import css from './EditListingPage.module.css';

const BackButton: FC = () => {
  const isMobile = useIsMobile();

  return (
    <BackToPreviousTabLink style={{ display: 'flex' }}>
      <InlineTextButton style={{ display: 'flex', alignItems: 'center' }}>
        <Box display="flex" alignItems="center">
          <IconArrowLeft />
          <TypographyWrapper
            variant="body1"
            typographyOverrides={{ display: 'inline', style: { marginLeft: '4px' } }}
          >
            {isMobile ? 'Back' : 'Choose Item'}
          </TypographyWrapper>
        </Box>
      </InlineTextButton>
    </BackToPreviousTabLink>
  );
};

interface FooterProps {
  saveDraftButton?: React.ReactElement;
  submitButton?: React.ReactElement;
}

const Footer: FC<FooterProps> = (props) => {
  const { submitButton, saveDraftButton } = props;

  const { css: brandCss } = useShopConfig();

  const { params } = useSelector<any>((state) => state.EditListingPage) as EditListingPageState;
  const { tab } = params || {};

  const { currentListing } = useOwnListingVersions();
  const listingState = currentListing.attributes.state;
  // No listing state indicates that the listing has been started unauthed,
  // and has not yet been saved to sharetribe.
  const shouldShowBackButton =
    (listingState === LISTING_STATE_DRAFT || !listingState) && tab === ListingPageParamTab.Details;

  return (
    <Box
      display="flex"
      justifyContent="center"
      bgcolor={brandCss?.backgroundColor || defaultTreetStyles.gray10}
      className={css.footer}
    >
      <Box
        className={css.footerLiner}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        {shouldShowBackButton ? <BackButton /> : <div />}
        <Box display="flex">
          {saveDraftButton}
          {submitButton}
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
